import { render, staticRenderFns } from "./TrafficLicenseForm.vue?vue&type=template&id=6e030065"
import script from "./TrafficLicenseForm.vue?vue&type=script&lang=js"
export * from "./TrafficLicenseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports